import { Endpoint } from '../endpoint';
import {
  ClockinResponse,
  ClockinID,
  ClockinPageQuery,
  ClockinReportData,
  UserClockReportQuery,
  UserClockReportResponse,
  TeamClockinResponse,
  ClockinTimesheetResponse,
} from '@business/entities/clockin';
import { UserId } from '@business/entities/account';
import { TeamId } from '@business/entities/team';
import { ClockinTeamDetailsFormData } from '@modules/clockin/ClockinTeamDetailsOverlay/Tabs/ClockinTeamsTab';
import { ClockinReportFormData } from '@modules/clockin/ClockinExportModal/ClockinExportModal';
import { JobId } from '@business/entities/job';

export function getAll(params: ClockinPageQuery) {
  return Endpoint.get<ClockinReportData[]>(`@gc/clock-in-report`, { params });
}

export function getUserReport(userId: UserId, params: UserClockReportQuery) {
  return Endpoint.get<UserClockReportResponse[]>(`@gc/clock-in-report/user-report/${userId}`, { params });
}

export function getTeamReport(teamId: TeamId, params: ClockinTeamDetailsFormData) {
  return Endpoint.get<TeamClockinResponse>(`@gc/clock-in-report/team-timesheet/${teamId}`, { params });
}

export function getUserTimesheet(userId: UserId, params: ClockinTeamDetailsFormData) {
  return Endpoint.get<ClockinTimesheetResponse>(`@gc/clock-in-report/user-timesheet/${userId}`, { params });
}

export function exportReport(params: ClockinReportFormData) {
  return Endpoint.get<ClockinTimesheetResponse>(`@gc/clock-in-report/export`, { params });
}

export function downloadExport(jobId: JobId, filename: string) {
  return Endpoint.get<void>(`@gc/clock-in-report/download-export/${jobId}`, { isFile: true, filename });
}
